import TrackString from "../../../analytics/TrackString";
import AbstractCommand from "../../../core/application/AbstractCommand";
import ConversationPhaseChangedEvent from "../event/ConversationPhaseChangedEvent";

export default class ConversationPhaseChangedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        /** @type {ConversationPhaseChangedEvent} */
        const data = evt.params.data;
        const { conversation, phaseId, previousPhaseId } = data;

        // Track analytics.
        this.trackEvent(TrackString.EVENT_CONVERSATION_PHASE_ENTER, TrackString.createConversationPhaseChangedParams({
            conversationId: conversation.id,
            phaseId,
            previousPhaseId,
            turnIndex: conversation.getTotalTurns(),
        }));
    }
}